// extracted by mini-css-extract-plugin
export default {"row":"DataTable_row__yRIaq","tableWrapper":"DataTable_tableWrapper__QH7ql","redirectButton":"DataTable_redirectButton__qNkh0"};